export var createEmitter = function (initial, namespace) {
    var last = initial;
    var handlers = [];
    var isSSR = typeof window === 'undefined';
    var emitter = {
        addListener: function (cb) {
            handlers.push(cb);
            return function () {
                handlers = handlers.filter(function (h) { return cb !== h; });
            };
        },
        publish: function (item) {
            last = item;
            handlers.forEach(function (handler) { return handler(item); });
        },
        getLast: function () { return last; }
    };
    // init singleton object
    if (!isSSR && !window.__emitters) {
        window.__emitters = {};
    }
    // create namespace singleton if needed
    if (!isSSR && namespace && !window.__emitters[namespace]) {
        window.__emitters[namespace] = emitter;
    }
    return !isSSR && namespace ? window.__emitters[namespace] : emitter;
};
//# sourceMappingURL=index.js.map